import { StatusUnionType } from '@api';
import { Badge } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { getColor } from './helpers';

type StatusBadgePropsType = {
  status: StatusUnionType;
};

export const StatusBadge: React.FC<StatusBadgePropsType> = ({ status }) => {
  const { t } = useTranslation();
  const { backgroundColor, textColor } = getColor(status);

  return (
    <Badge color={backgroundColor} style={{ color: textColor }}>
      {t(`STATUS.${status}`)}
    </Badge>
  );
};
